import {
  customersAuthorizationApi,
  ECustomerAuthorizationEndpoints
} from '../api';
import { EGerdauService } from '../EGerdauService';
import {
  ICMSResponse,
  IProductFindParam,
  IProductInfo,
  IRelatedProducts
} from './types';
import { EndpointsMvp } from '../MVP/enum';

export class ProductService extends EGerdauService {
  constructor() {
    super();
  }

  async getProduct(params: IProductFindParam): Promise<IProductInfo[]> {
    const headers = new EGerdauService().getHeaders();

    const requestURL = `${ECustomerAuthorizationEndpoints.PRODUCTS}/${params.sku}?soldTo=${params.soldTo}&shipTo=${params.shipTo}`;
    const response = await customersAuthorizationApi.get(requestURL, {
      headers
    });
    return response.data;
  }

  async getRelatedProducts(
    params: IProductFindParam
  ): Promise<IRelatedProducts> {
    const headers = new EGerdauService().getHeaders();

    const requestURL = `${ECustomerAuthorizationEndpoints.PRODUCTS}/${params.sku}/relatedProducts?soldTo=${params.soldTo}&shipTo=${params.shipTo}`;
    const response = await customersAuthorizationApi.get(requestURL, {
      headers
    });
    return { related: response.data };
  }

  async getProductArticle(categoryName: string): Promise<ICMSResponse> {
    const headers = new EGerdauService().getHeaders();
    const field = 'url_key';
    const conditionType = 'eq';

    const requestURL = `/commerce${EndpointsMvp.CATEGORIES_LIST(
      field,
      categoryName,
      conditionType
    )}`;
    const response = await customersAuthorizationApi.get(requestURL, {
      headers
    });

    return response.data.items[0];
  }
}
